<template>
  <div class="machine-monitor-wrap">
    <!-- 顶部标题栏 -->
    <div class="top-header">
      <div class="header-left">
        <span class="tag-btn"> <!--<img src="../assets/img/start-top.png" alt="">-->{{form.state === 0 ? '在线' : form.state === 1 ? '在线' : '离线'}} | {{ (form.state === 0 || form.state === 1) ? ((serialData !== "等待串口数据…" && Number(serialData) > 0) ? '运行中':'空闲') : '未开机' }}</span>
      </div>
      <div class="header-title">{{ form.name ? form.name : ' ' }}</div>
<!--      <div class="header-time">&lt;!&ndash;<img src="../assets/img/time-top.png" alt="">&ndash;&gt; {{ form.date }}</div>-->
    </div>

    <div class="main-content">
      <!-- 左侧印刷速度大面板 -->
      <div class="speed-card">
<!--        <div class="card-title">印刷速度（张/时）</div>-->
<!--        <div class="speed-num">{{ form.state !== -2 ? formatSpeed(form.speed) : '-' }}</div>-->
        <div class="speed-num">{{ serialData === "等待串口数据…" ? '0' : serialData }}</div>
        <div class="text-center ">国家行业标准化CY/T 212-2020印刷机适印状态监测器</div>
      </div>

      <!-- 右侧参数信息区 -->
      <div class="right-info-group">
        <!-- 第一块：水质参数 :class="{ warningBorder: isAnyOverLimit }"-->
        <div class="info-card water-card water-card1"  >
          <div class="info-item">
            <span class="label"><!--<img src="@/assets/img/icon-c.png" class="ddl" alt=""> :class="{
         warning: isDdlOver,
      normal: !isDdlOver
      }"--> 电导率:</span>
            <span class="value"  :class="{
         warning: isDdlOver,
      normal: !isDdlOver
      }">{{ form.state !== -2 ? (form.ddl ? form.ddl  : '' ) : '' }}</span>
          </div>
          <div class="info-item">
            <span class="label"><!--<img src="@/assets/img/icon-ph.png" alt="">:class="{
       warning: isPhOver,
      normal: !isPhOver
      }"--> 酸碱度:</span>
            <span class="value" :class="{
       warning: isPhOver,
      normal: !isPhOver
      }">{{ form.state !== -2 ?( form.ph ? form.ph : '' ) : '' }}</span>
          </div>
          <div class="info-item">
            <span class="label"><!--<img src="@/assets/img/icon-t.png" alt=""> :class="{
       warning: isWdOver,
      normal: !isWdOver
      }"--> 水温:</span>
            <span class="value" :class="{
       warning: isWdOver,
      normal: !isWdOver
      }"
                 >{{ form.state !== -2 ? (form.wd ? form.wd  : '' ) : ''  }}</span>
          </div>
        </div>

        <!-- 第二块：当日生产数据 -->
        <div class="info-card water-card">
          <div class="info-item info-item-text">
            <span class="label"><!--<img src="@/assets/img/icon-number.png" alt="">--> 日印刷数:</span>
<!--            <span class="value">{{ form.count }}</span>-->
            <span class="value">{{ dayPrintCount }}</span>
          </div>
          <div class="info-item info-item-text">
            <span class="label"><!--<img src="@/assets/img/yinshu.png" alt="">--> 日试印数:</span>
            <span class="value">{{ form.noCount }}</span>
          </div>
          <div class="info-item info-item-text">
            <span class="label"><!--<img src="@/assets/img/icon-item.png" alt="">--> 日开机时:</span>
            <span class="value">{{ formatHourTime(form.time) }}</span>
          </div>
        </div>

        <!--        &lt;!&ndash; 第三块：温湿度 &ndash;&gt;-->
        <!--        <div class="info-card">-->
        <!--          <div class="info-item">-->
        <!--            <span class="label">🌡️ 室内温度:</span>-->
        <!--            <span class="value">25.5</span>-->
        <!--          </div>-->
        <!--          <div class="info-item">-->
        <!--            <span class="label">💦 室内湿度:</span>-->
        <!--            <span class="value">60.5</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <!-- 底部四栏信息 -->
    <div class="bottom-row">
      <!-- 设备规格 -->
      <div class="bottom-card">
        <div class="spec-item"><span class="item">最小印刷幅面：</span><span class="blue-text">{{ form.minPrintWidth }}x{{ form.minPrintHeight }}mm</span></div>
        <div class="spec-item"><span class="item">最大印刷幅面：</span><span class="blue-text">{{ form.maxPrintWidth }}x{{ form.maxPrintHeight }}mm</span></div>
        <div class="spec-item"><span class="item">承印纸张厚度：</span><span class="blue-text">{{ form.minPaperThickness }}-{{ form.maxPaperThickness }}mm</span></div>
        <div class="spec-item"><span class="item">最高印刷速度：</span><span class="blue-text"> {{ form.maxSpeed }}张/小时</span></div>
      </div>
      <!-- 机台负责人 -->
      <div class="bottom-card person-card">
        <div class="card-subtitle">机台负责人</div>
        <div class="person-name">{{ personDisplay }}</div>
      </div>
      <!-- 机件预警 -->
      <div class="bottom-card maintain-card">
        <div class="card-subtitle">机件预警</div>
<!--        <div class="notab" v-if="form.maintainList.length < 1">暂无数据</div>-->
<!--        <div class="maintain-tabs">-->
<!--          <span-->
<!--              class="tab"-->
<!--              :class="{ active: form.noMaintainList.includes(item) }"-->
<!--              v-for="item in form.maintainList"-->
<!--              :key="item"-->
<!--          >-->
<!--            {{ maintainMap[item] || item }}-->
<!--          </span>-->

<!--        </div>-->
      </div>
      <!-- 保养提醒 -->
<!--      <div class="bottom-card maintain-card">-->
<!--        <div class="card-subtitle">保养提醒</div>-->
<!--        <div class="notab" v-if="form.maintainList.length < 1">暂无数据</div>-->
<!--        <div class="maintain-tabs">-->
<!--          <span-->
<!--              class="tab"-->
<!--              :class="{ active: form.noMaintainList.includes(item) }"-->
<!--              v-for="item in form.maintainList"-->
<!--              :key="item"-->
<!--          >-->
<!--            {{ maintainMap[item] || item }}-->
<!--          </span>-->

<!--        </div>-->
<!--      </div>-->
      <!-- 保养提醒 -->
      <div class="bottom-card temp-hum-card" :class="{ error: shouldMaintainError }">
        <div class="info-item">
          <span class="label"><!--<img src="@/assets/img/snwd.png" alt="">--> 保养<br>提醒</span>
<!--          <span class="value">{{ form.state !== -2 ? (form.temperature ? Number(form.temperature).toFixed(1) + '℃' : '-' + '℃' ) : '-' + '℃'}}{{ form.date }}</span>-->
          <div style="width: 70%;line-height: 1;text-align: center;">
               <div
                   class="tab"
               >
                 双周保养
<!--                      {{ form.maintainType ? maintainMap[form.maintainType] : '下次保养' }}-->
<!--                 maintainType-->
                    </div>
            <div class="time">{{ form.maintainType ? form.maintainTime : form.nextMaintainTime }}</div>
          </div>


        </div>
<!--        <div class="info-item">-->
<!--          <span class="label">&lt;!&ndash;<img src="@/assets/img/snsd.png" alt="">&ndash;&gt; 室内湿度:</span>-->
<!--          <span class="value">{{ form.state !== -2 ? (form.humidity ? Number(form.humidity).toFixed(1) + '%' : '-' + '%') : '-' + '%' }}</span>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
export default {
  name: 'PrintMachineMonitor',
  data() {
    return {
      maintainMap: {
        1: '日保养',
        2: '周保养',
        3: '月保养',
        4: '季保养',
        5: '半年保养',
        6: '年保养',
        30: '半月保养'
      },
      form: {
        date: '',
        maintainList: [],     // 所有保养项：['日','周','月','半月','季','年']
        noMaintainList: []    // 未保养项：['月','半月']
      },
      timer: null, // 定时器
      timerData: null,   // 接口刷新定时器
      lastDateTime: 0,    // 接口返回的时间戳（毫秒）
      serialData: '等待串口数据…',
      serialDataC: '等待串口数据…',
      // 保存上一次有效 c 值
      lastValidC: null,
      serialTs: 0,
      baseAllCount: 0, // 新增：接口返回的基准总数
      // 新增：串口超时计时器
      serialTimeoutTimer: null,
      maintainTime: {
        'S23#': '2026-08-26 07:45:00',
        'S4#': '2026-08-18 07:45:00',
        'S31#': '2026-08-24 07:45:00',
        'S6#': '2026-08-21 07:45:00',
        'S17#': '2026-08-21 07:45:00',
        'S10#': '2026-08-20 07:45:00',
        'S1#': '2026-08-17 07:45:00',
        'S27#': '2026-08-27 07:45:00',
        'S30#': '2026-08-19 07:45:00',
        'S2#': '2026-08-14 07:45:00',
        'S28#': '2026-08-18 07:45:00'
      },
    }
  },
  computed: {
    isDdlOver() {
      const { ddl, electricityDown, electricityUp } = this.form
      if (!ddl || electricityDown == null || electricityUp == null) return false
      return ddl < electricityDown || ddl > electricityUp
    },
    isPhOver() {
      const { ph, phDown, phUp } = this.form
      if (!ph || phDown == null || phUp == null) return false
      return ph < phDown || ph > phUp
    },
    isWdOver() {
      const { wd, temperaturDown, temperaturUp } = this.form
      if (!wd || temperaturDown == null || temperaturUp == null) return false
      return wd < temperaturDown || wd > temperaturUp
    },
    isAnyOverLimit() {
      return this.isDdlOver || this.isPhOver || this.isWdOver
    },
    // 日印刷数
    dayPrintCount() {
      const v = Number(this.serialDataC)
      if (isNaN(v) || this.serialDataC === '等待串口数据…') {
        return this.form.count
      }
      return Math.max(0, v - this.baseAllCount)

      // // 未收到串口数据时，优先展示接口form.count
      // if (this.serialDataC === '等待串口数据…') {
      //   return Number(this.form.count || 0)
      // }
      // const v = Number(this.serialDataC)
      // if (isNaN(v)) {
      //   return Number(this.form.count || 0)
      // }
      // return Math.max(0, v - this.baseAllCount)
    },
    personDisplay(){
      if(!this.form.person) return '-'
      const arr = this.form.person.split(',')
      //超过2个只取前两个
      if(arr.length > 2){
        return arr.slice(0,2).join('/')
      }else{
        return arr.join('/')
      }
    },
    // 保养提醒是否闪红：保养日期当天 07:45 为临界点，过点即闪
    shouldMaintainError() {
      const t = this.form.maintainTime
      if (!t) return false
      const deadlineStr = (t.includes(' ') ? t : t + ' 07:45:00').replace(/-/g, '/')
      const deadline = new Date(deadlineStr).getTime()
      if (isNaN(deadline)) return false
      return Date.now() >= deadline
    }
  },
  mounted() {
    window.onSerialData = this.handler
    this.getDaPingJiTaiYuTong()
    this.timerData = setInterval(() => {
      this.getDaPingJiTaiYuTong()
    }, 15000) // 10 秒
    // 每秒刷新一次时间
    this.timer = setInterval(() => {
      this.addOneSecond()
    }, 1000)
  },
  beforeDestroy() {
    delete window.onSerialData
    // 页面销毁清除定时器
    clearInterval(this.timer)
    clearInterval(this.timerData)

    // 清除串口超时计时器
    if (this.serialTimeoutTimer) {
      clearTimeout(this.serialTimeoutTimer)
    }
  },
  methods: {
    handler(payload) {
      // 清除之前的超时计时器
      if (this.serialTimeoutTimer) {
        clearTimeout(this.serialTimeoutTimer)
      }

      const v = Number(payload.data.v) // 速度
      if (v <= 99999) {
        this.serialData = payload.data.v
      }
      const currentC = Number(payload.data.c) // 日印刷数

      // ===================== 核心逻辑 =====================
      if (!isNaN(currentC)) {
        if (this.lastValidC == null) {
          // 第一次：直接赋值
          this.serialDataC = currentC
          this.lastValidC = currentC
        } else {
          // 比上次大 100 倍（两个量级）则丢弃本次
          if (currentC >= this.lastValidC * 100 || currentC < this.lastValidC) {
            console.log('数据异常（跳变/减小），丢弃：', currentC, '保留：', this.lastValidC)
          } else {
            // 正常更新
            this.serialDataC = currentC
            this.lastValidC = currentC
          }
        }
      }
      // 1 秒后没更新就置为 --
      this.serialTimeoutTimer = setTimeout(() => {
        this.serialData = 0
      }, 12000)
      // }
      console.log(this.serialData,this.serialTs,'--------2')
    },
    // 以基准时间为锚点，按14天周期向后滚动：过了保养日零点即进入下一周期
    calcMaintainTime(baseStr) {
      const base = new Date(baseStr.replace(/-/g, '/'))
      if (isNaN(base.getTime())) return baseStr
      const dayStart = d => { const x = new Date(d); x.setHours(0,0,0,0); return x }
      const diffDays = Math.floor((dayStart(new Date()) - dayStart(base)) / 86400000)
      const n = Math.max(0, Math.ceil(diffDays / 14))
      const next = new Date(base.getTime() + n * 14 * 86400000)
      const p = v => String(v).padStart(2, '0')
      return `${next.getFullYear()}-${p(next.getMonth()+1)}-${p(next.getDate())} ` +
          `${p(next.getHours())}:${p(next.getMinutes())}:${p(next.getSeconds())}`
    },

    getDaPingJiTaiYuTong() {
      console.log(this.$route.query.deviceId)
      API.DaPingJiTaiYuTong({deviceId: this.$route.query.deviceId}).then(res => {
        console.log(res)
        this.form = res.message.data
        console.log(this.form,'----')
        this.baseAllCount = Number(this.form.allCount || 0)
        // ===== 根据设备名截取前4位 Sxx# 匹配保养时间 =====
        if (this.form.name) {
          // 按#分割，拿到 #前面部分，再拼接回 #
          const nameParts = this.form.name.split('#')
          if(nameParts.length >=2){
            const shortKey = nameParts[0] + '#'
            if (this.maintainTime[shortKey]) {
              this.form.maintainTime = this.calcMaintainTime(this.maintainTime[shortKey])
              // this.form.maintainTime = this.maintainTime[shortKey]
              console.log('匹配保养key：', shortKey, '保养时间：', this.form.maintainTime)
            }
          }
        }
        if (this.form.maintainList && this.form.maintainList.length) {
          this.form.maintainList.sort((a, b) => a - b)
        }
        console.log(this.form)
        if (this.form.date) {
          this.lastDateTime = new Date(this.form.date).getTime()
        }
      })
    },
    formatHourTime(val) {
      if (val == null || val === '-' || isNaN(val)) return '--:--'
      // 拆分为小时和小数部分
      const hours = Math.floor(val)
      const minutes = Math.round((val - hours) * 60)
      // 补零
      const hh = String(hours).padStart(2, '0')
      const mm = String(minutes).padStart(2, '0')
      return `${hh}:${mm}`
    },
    formatSpeed(speed) {
      const num = Number(speed)
      if (isNaN(num)) return '-'
      // 等于0直接返回0
      if (num === 0) return 0
      // 否则抹掉后两位
      return Math.floor(num / 100) * 100
    },
    // 每秒 +1 秒并格式化
    addOneSecond() {
      if (!this.lastDateTime) return
      // 加 1000 毫秒
      this.lastDateTime += 1000
      // 格式化为 2026-06-13 15:09:36
      this.form.date = this.formatDate(new Date(this.lastDateTime))
    },

    // 日期格式化
    formatDate(date) {
      const y = date.getFullYear()
      const m = this.addZero(date.getMonth() + 1)
      const d = this.addZero(date.getDate())
      const h = this.addZero(date.getHours())
      const min = this.addZero(date.getMinutes())
      const s = this.addZero(date.getSeconds())
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },

    // 补零
    addZero(num) {
      return num < 10 ? '0' + num : num
    },
    currentTime(){
      setInterval(()=>{
        this.getDaPingJiTaiYuTong()
      },10000)
    },
  }
}
</script>

<style scoped lang="scss">
$header-bg: #407080;    // 顶部蓝
$speed-card-bg: #242e42;    // 左侧深蓝
$param-card-bg: #c8a050;    // 右侧橙黄，代码里要更亮
$bottom-card-bg: #407080;    // 底部蓝
.wrapper {
  width: 100%;
  height: 100vh;
  background: #333;
  padding: 16px;
  box-sizing: border-box;
}

.machine-monitor-wrap {
  width: 100%;
  height: 100vh;
}

/* 顶部标题栏 */
.top-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px 18px;
  background-color: $header-bg; /* 原亮蓝 → 灰蓝 */
  color: #c8d1d8;
  position: relative;
  margin: 10px 10px 0;
  height: 110px;

  .tag-btn {
    font-size: 42px;
    position: absolute;
    left: 50px;
    top: 20px;
    font-weight: bold;
    img {
      width: 24px;
      margin-right: 15px;
    }
  }

  .header-title {
    font-size: 65px;
    font-weight: bold;
    color: #e3e9ef;
  }

  .header-time {
    font-size: 32px;
    color: #c8d1d8;
    position: absolute;
    top: 25px;
    right: 30px;
    img {
      width: 24px;
      margin-right: 20px;
    }
  }
}

/* 主体区域 */
.main-content {
  display: flex;
  gap: 4px;
  padding: 8px;
  flex: 1;

  .speed-card {
    flex: 1;
    border-radius: 6px;
    padding: 14px;
    border: 1px solid #555;
    background-color:$speed-card-bg; /* 深蓝灰，不刺眼 */
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
    .card-title {
      font-size: 50px;
      color: #d0dbe7;
      margin-bottom: 30px;
    }

    .speed-num {
      font-size: 440px;
      font-weight: bold;
      color: #e3e9ef;
      line-height: 1.395;
      text-align: center;
    }

    .text-center {
      font-size: 40px;
      color: #c8d1d8;
    }
  }

  .right-info-group {
    width: 30.3%;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .info-card {
      background: $param-card-bg; /* 亮黄 → 暗金灰 */
      border: 1px solid #777;
      border-radius: 6px;
      padding: 0px 20px;
      flex: 1;
      box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.2);

      .info-item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .label {
          color: #2a2a2a;
          font-size: 48px;
          font-weight: bold;
        }

        .value {
          font-size: 64px;
          font-weight: bold;
          color: #222;
          width: 40%;
        }

        img{
          width: 30px;
        }

        .ddl {
          width: 24px;
        }
      }
    }

    .water-card {
      display: flex;
      flex-direction: column;
      padding: 0px 20px;

      .info-item {
        flex: 1;
        margin: 0;
      }
      .info-item-text .value {
        text-align: center;
      }
    }
    .water-card1{
      margin-bottom: 4px;
    }
  }
}

/* 底部四栏 */
.bottom-row {
  display: grid;
  grid-template-columns: 1.22fr 1.21fr 1.21fr 1.6fr;
  gap: 4px;
  padding: 0 8px 8px;

  .bottom-card {
    border: 1px solid #666;
    border-radius: 6px;
    padding: 10px 0px 10px 10px;
    background-color: $bottom-card-bg; /* 统一灰蓝 */
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;

    .card-subtitle {
      font-size: 48px;
      margin-bottom: 20px;
      color: #bcc6d0;
    }
  }

  /* 设备规格栏 */
  .spec-item {
    font-size: 32px;
    margin: 3px 0;
    display: flex;
    //justify-content: space-between;
    align-items: center;
    color: #d4d9de;
.item{
  font-weight: bold;
}
    .blue-text {
      color: #e3e9ef;
      font-weight: bold;
    }
  }

  /* 负责人 */
  .person-card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .person-name {
      font-size: 52px;
      color: #e3e9ef;
      font-weight: bold;
      text-align: center;
      width: 410px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  /* 保养标签 */
  .maintain-card {
    display: flex;
    flex-direction: column;
    align-items: center;

    .maintain-tabs {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 8px;

      .tab {
        width: 100px;
        height: 80px;
        display: flex;
        align-items: end;
        justify-content: center;
        font-size: 48px;
        border-radius: 4px;
        color: #e3e9ef;

        &.active {
          background: #3a6a99;
          color: #fff;
        }
      }

      .year-tab {
        grid-column: 3;
        grid-row: 2;
      }
    }

    .notab {
      font-size: 36px;
      color: #e3e9ef;
    }
  }

  /* 底部温湿度 */
  .temp-hum-card {
    display: flex;
    flex-direction: column;

    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
      //margin: 16px 0;
      padding: 0px 30px;
      //flex: 1;

      .label {
        color: #bcc6d0;
        font-size: 68px;
        display: inline-block;
        width: 200px;
        font-weight: bold;
      }

      .tab{
        font-size: 52px;
        color: #e3e9ef;
        text-align: center;
      }

      .time{
        font-size: 52px;
        color: #e3e9ef;
        display: inline-block;
        text-align: center;
        margin-top: 10px;
      }

      img{
        width: 30px;
      }
    }
  }
}

/* 正常范围内颜色 */
.normal {
  color: #222 !important;
}

/* 柔和警告：暗红灰，不艳红 */
.warning {
  background-color: $param-card-bg ;
  //color: #fff !important;
  animation: warningFlashyellowRed 0.7s infinite alternate ease-in-out;
}
/* 闪动红边框 */
.warningBorder {
  border: 2px solid #db5151;
  animation: warningFlashIn 0.5s infinite alternate ease-in-out;
}
@keyframes warningFlash {
  0% { background-color: #db5151; }
  100% { background-color: $param-card-bg; }
}

/* 保养提醒柔和闪烁 */
.error {
  background-color: #db5151;
  animation: warningBlueRed 0.7s infinite alternate ease-in-out;
}
@keyframes warningBlueRed {
  0% { background-color: #db5151; }
  100% { background-color: $bottom-card-bg; }
}
@keyframes warningFlashBlueRed {
  0% { background-color: #a82a27; }
  100% { background-color: $bottom-card-bg; }
}
@keyframes warningFlashyellowRed {
  0% { background-color: $param-card-bg; }
  100% { background-color: #db5151; }
}
</style>
